import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceDateSeparator'
})
export class ReplaceDateSeparatorPipe implements PipeTransform {

  transform(value: string, separator: string): string {
    const regex = /(\d{2})\/(\d{2})\/(\d{4})/g;
    const replacement = `$1${separator}$2${separator}$3`;
    return value.replace(regex, replacement);
  }
}
